import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { UnidadeMedidaService } from '../services/unidade-medida.service';

@Component({
	selector: 'app-unidades-medida',
	templateUrl: './unidades-medida.component.html',
	styleUrls: ['./unidades-medida.component.css'],
	animations: [loadingFade, modal, alert]
})
export class UnidadesMedidaComponent implements OnInit {
	public loading = false;
	public unidades = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalApagar = 'hidden';
	public idUnidadeMedidaApagar = null;

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	constructor(private fb: FormBuilder,
				private unidMedidaSvc: UnidadeMedidaService) { }

	ngOnInit() {
		this.pegaUnidades();
	}

	pegaUnidades() {
		this.unidades = [];
		this.loading = true;
		this.unidMedidaSvc.getUnidadesMedida('unidade_medida_id').then((data: any[]) => {
			this.unidades = data;
			this.count = this.unidades.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	perguntaApagar(id) {
		this.modalApagar = 'shown';
		this.idUnidadeMedidaApagar = id;
	}

	cancelaApagar() {
		this.modalApagar = 'hidden';
	}

	apagaUnidadeMedida() {
		this.modalApagar = 'hidden';
		this.loading = true;
		this.unidMedidaSvc.apagaUnidadeMedida(this.idUnidadeMedidaApagar).then((data) => {
			this.mostraMsg('Unidade apagada com sucesso.', 'alert-success');
			this.pegaUnidades();
		}).catch((err) => {
			console.log(err);
			this.mostraMsg('Problema ao apagar unidade.', 'alert-danger');
			this.loading = false;
		});
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}
}
